import { getNumericMetric } from '@utils/metrics/rateMetrics';
import { useAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { useDebounce } from 'react-use';
import { tableMetricsAtom } from '../atoms';
import { dimensionMetricsSelector, globalOrderBySelector } from '@store/trends/base/selectors';
import ignoreRefetch from '@utils/metrics/ignoreRefetch';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { getSecondaryMetric } from '@src/utils/metrics/metricHelpers';

// build and manage local list of query metrics to reduce refetches
function useTableMetrics() {
  const metrics: string[] = useSelector(dimensionMetricsSelector);
  const selectedMetric = useSelector(selectedMetricSelector);
  const orderBy =
    useSelector(globalOrderBySelector) ||
    getSecondaryMetric({
      metricKey: selectedMetric,
    }) ||
    selectedMetric;
  const [tableMetrics, setTableMetrics] = useAtom(tableMetricsAtom);

  // debouce is required here as order by and metric changes are two different saga actions that happen together
  useDebounce(
    () => {
      const currentTableMetrics = [
        ...new Set([...metrics, ...metrics.map(getNumericMetric)]),
      ].sort();
      const { metrics: prevTableMetrics, orderBy: prevOrderBy }: any = tableMetrics;
      if (!ignoreRefetch(currentTableMetrics, prevTableMetrics) || orderBy !== prevOrderBy) {
        setTableMetrics({ metrics: currentTableMetrics, orderBy });
      }
    },
    100,
    [metrics, orderBy],
  );
}

export default useTableMetrics;
